import React, { useMemo, useCallback } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import BasicUserName from '../../../User/BasicUserName';
import UserAvatar from '../../../User/Avatar';
import IconButtonWithContextMenu from '../../../Dropdown2/Preset/IconButtonWithContextMenu';
import MoreIcon from '../../../Icons/Ellipsis';
import { useWatchButton } from '../../../WatchButton/useWatchButton';
import PinIcon from '../../../Icons/Pin';
import NewContentIndicator from '../NewContentIndicator';
import ConditionalTooltip from '../ConditionalTooltip';
import Flex from '../../../Flex';
import s from './NetworkBarGroupLink.scss';
var NetworkBarGroupLink = function (_a) {
    var group = _a.group, className = _a.className, isSelected = _a.isSelected, _b = _a.isCollapsed, isCollapsed = _b === void 0 ? false : _b, tabIndex = _a.tabIndex, togglePinGroup = _a.togglePinGroup, toggleWatchGroup = _a.toggleWatchGroup, unrecommendGroup = _a.unrecommendGroup;
    var _c, _d;
    var t = useTranslation().t;
    var onWatchToggle = useCallback(function (isWatching) { return toggleWatchGroup(group.userId, isWatching); }, [toggleWatchGroup, group.userId]);
    var _e = useWatchButton(group, group.isWatching, undefined, false, onWatchToggle), onWatchClick = _e.onClick, isWatching = _e.isWatching;
    var menuItems = useMemo(function () {
        var _a;
        return [
            isWatching &&
                (((_a = group.networkbar) === null || _a === void 0 ? void 0 : _a.isPinned) ? {
                    label: t('networkBar.groups.group.actions.unpin'),
                    onClick: function () { return togglePinGroup(group.userId, false); },
                }
                    : {
                        label: t('networkBar.groups.group.actions.pin'),
                        onClick: function () { return togglePinGroup(group.userId, true); },
                    }),
            isWatching
                ? {
                    label: t('networkBar.groups.group.actions.unwatch'),
                    onClick: onWatchClick,
                }
                : {
                    label: t('networkBar.groups.group.actions.watch'),
                    onClick: onWatchClick,
                },
            {
                label: t('networkBar.groups.group.actions.visit'),
                link: Url.userLink(group.username),
            },
            !isWatching && {
                label: t('networkBar.groups.group.actions.unrecommend'),
                onClick: function () { return unrecommendGroup(group.userId); },
            },
        ];
    }, [
        isWatching,
        group.networkbar,
        group.userId,
        group.username,
        t,
        togglePinGroup,
        unrecommendGroup,
        onWatchClick,
    ]);
    return (React.createElement(ConditionalTooltip, { tooltipContent: React.createElement(React.Fragment, null,
            !group.isWatching && (React.createElement("div", { className: s['recommended-tooltip-label'] }, t('networkBar.navItems.group.tooltip.recommended'))),
            React.createElement(Flex, { alignItems: "center" },
                group.username,
                ((_c = group.networkbar) === null || _c === void 0 ? void 0 : _c.isPinned) && (React.createElement(PinIcon, { customSizable: true, disableDefaultColors: true, className: s['pin-icon'] })))), showTooltip: isCollapsed },
        React.createElement("a", { href: Url.browseGroupFeedLink(group.username), className: classnames(s['root'], isSelected && s['selected'], isCollapsed && s['collapsed'], className), tabIndex: tabIndex },
            React.createElement("div", { className: s['avatar'] },
                React.createElement(UserAvatar, { user: group, size: isCollapsed ? 24 : 32, withLink: false }),
                ((_d = group.networkbar) === null || _d === void 0 ? void 0 : _d.hasNewContent) && (React.createElement(NewContentIndicator, { className: s['highlight'], bottomCircleClassName: s['highlight-bottom'] }))),
            !isCollapsed && (React.createElement(React.Fragment, null,
                React.createElement("span", { className: s['username'] },
                    React.createElement(BasicUserName, { user: group, showSymbol: false })),
                React.createElement("div", { onClick: function (e) {
                        // trap clicks from triggering the link
                        e.stopPropagation();
                        e.preventDefault();
                    } },
                    React.createElement(IconButtonWithContextMenu, { className: s['actions'], withButton: true, noIconHoverEffect: true, items: menuItems },
                        React.createElement(MoreIcon, { disableDefaultColors: true, className: s['more'] }))))))));
};
NetworkBarGroupLink.displayName = 'NetworkBarGroupLink';
export default NetworkBarGroupLink;
//# sourceMappingURL=NetworkBarGroupLink.js.map